/* MRG video landing runtime — one instance per section, installed once per page. */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.mwMrgLanding) { W.mwMrgLanding.initAll(); return; }
  var MQ = '(max-width: 768px)';
  var reduce = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var designMode = !!(W.Shopify && W.Shopify.designMode);
  function q(sel, root) { return (root || D).querySelector(sel); }

  function init(root) {
    if (!root || root.mwMrg) return;
    var video = q('[data-mw-mrg-video]', root), stage = q('[data-mw-mrg-stage]', root), srcEl = q('[data-mw-mrg-sources]', root);
    if (!video || !stage || !srcEl) return;
    var sources; try { sources = JSON.parse(srcEl.textContent); } catch (err) { return; }
    var toggle = q('[data-mw-mrg-toggle]', root), sound = q('[data-mw-mrg-sound]', root), big = q('[data-mw-mrg-bigplay]', root);
    var st = { mode: null, userPaused: false, autoPaused: false, ended: false, playing: false, inView: true, destroyed: false, pending: 0,
      autoplay: root.getAttribute('data-mw-mrg-autoplay') === 'true', loop: root.getAttribute('data-mw-mrg-loop') === 'true' };
    root.mwMrg = st;
    var mq = W.matchMedia ? W.matchMedia(MQ) : { matches: false, addEventListener: function () {}, removeEventListener: function () {} };
    video.loop = st.loop; video.muted = true; video.defaultMuted = true;

    function status(s) { root.setAttribute('data-mw-mrg-status', s); }
    function buttons() {
      if (toggle) { toggle.textContent = st.playing ? 'PAUSE' : 'PLAY'; toggle.setAttribute('aria-pressed', st.playing ? 'true' : 'false'); }
      if (sound) { sound.textContent = video.muted ? 'SOUND OFF' : 'SOUND ON'; sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true'); }
      if (big) big.hidden = st.playing;
    }
    function wanted() { return mq.matches ? 'mobile' : 'desktop'; }
    function applySource(mode) {
      var s = sources[mode]; if (!s || !s.src) s = sources.desktop; if (!s || !s.src) { status('empty'); return false; }
      st.pending++; st.mode = mode; st.ended = false;
      root.setAttribute('data-mw-mrg-mode', mode); root.setAttribute('data-mw-mrg-fallback', s.fallback ? 'true' : 'false');
      try { video.pause(); } catch (err) {}
      video.removeAttribute('src'); while (video.firstChild) video.removeChild(video.firstChild);
      if (s.poster) video.setAttribute('poster', s.poster); else video.removeAttribute('poster');
      var source = D.createElement('source'); source.src = s.src; if (s.type) source.type = s.type;
      source.addEventListener('error', function () { if (st.mode === mode) status('error'); });
      video.appendChild(source); video.load(); status('idle'); st.playing = false; buttons();
      return true;
    }
    function tryPlay(user) {
      if (st.destroyed) return;
      if (!user && (reduce.matches || designMode || st.userPaused || st.ended || !st.inView || D.hidden)) return;
      if (user) { st.userPaused = false; st.autoPaused = false; st.ended = false; }
      var token = ++st.pending;
      var p; try { p = video.play(); } catch (err) { status('blocked'); return; }
      if (p && p.then) p.then(function () { /* 'play' event handles state */ }, function () { if (token !== st.pending || st.destroyed) return; st.playing = false; status(user ? 'error' : 'blocked'); buttons(); });
    }
    function pause(user) { if (user) st.userPaused = true; try { video.pause(); } catch (err) {} }

    video.addEventListener('play', function () { st.playing = true; status('playing'); buttons(); });
    video.addEventListener('playing', function () { st.playing = true; status('playing'); buttons(); });
    video.addEventListener('pause', function () { st.playing = false; if (!st.destroyed && root.getAttribute('data-mw-mrg-status') === 'playing') status(st.ended ? 'ended' : 'paused'); buttons(); });
    video.addEventListener('ended', function () { st.ended = true; st.playing = false; status('ended'); buttons(); });
    video.addEventListener('loadedmetadata', function () {
      var w = video.videoWidth, h = video.videoHeight; if (!w || !h) return;
      root.setAttribute('data-mw-mrg-meta', w + 'x' + h);
      var natural = root.getAttribute(st.mode === 'mobile' ? 'data-mw-mrg-natural-m' : 'data-mw-mrg-natural-d') === 'true';
      if (natural) root.style.setProperty(st.mode === 'mobile' ? '--mrg-ratio-m' : '--mrg-ratio-d', w + ' / ' + h);
    });
    video.addEventListener('volumechange', buttons);

    if (toggle) toggle.addEventListener('click', function () { if (st.playing) pause(true); else tryPlay(true); });
    if (big) big.addEventListener('click', function () { tryPlay(true); });
    if (sound) sound.addEventListener('click', function () { video.muted = !video.muted; buttons(); });

    function onMq() { var was = st.playing || (st.autoplay && !st.userPaused && !st.ended); if (applySource(wanted()) && was) tryPlay(false); }
    function onVis() { if (D.hidden) { if (st.playing) { st.autoPaused = true; pause(false); } } else if (st.autoPaused && !st.userPaused) { st.autoPaused = false; tryPlay(false); } }
    var io = null;
    if (W.IntersectionObserver) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          st.inView = e.isIntersecting;
          if (!st.inView) { if (st.playing) { st.autoPaused = true; pause(false); } }
          else if ((st.autoPaused || (st.autoplay && !st.playing && root.getAttribute('data-mw-mrg-status') === 'idle')) && !st.userPaused) { st.autoPaused = false; tryPlay(false); }
        });
      }, { threshold: 0.15 });
      io.observe(stage);
    }
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    D.addEventListener('visibilitychange', onVis);

    st.destroy = function () {
      st.destroyed = true; st.pending++;
      if (io) io.disconnect();
      if (mq.removeEventListener) mq.removeEventListener('change', onMq); else if (mq.removeListener) mq.removeListener(onMq);
      D.removeEventListener('visibilitychange', onVis);
      try { video.pause(); } catch (err) {}
      video.removeAttribute('src'); while (video.firstChild) video.removeChild(video.firstChild); try { video.load(); } catch (err) {}
      root.mwMrg = null;
    };

    if (applySource(wanted())) {
      if (st.autoplay) { if (reduce.matches) status('reduced'); else if (designMode) status('editor'); else tryPlay(false); }
    }
    buttons();
  }

  function initAll(scope) { var list = (scope || D).querySelectorAll('[data-mw-mrg]'); for (var i = 0; i < list.length; i++) init(list[i]); }
  function destroyAll(scope) { var list = (scope || D).querySelectorAll('[data-mw-mrg]'); for (var i = 0; i < list.length; i++) if (list[i].mwMrg && list[i].mwMrg.destroy) list[i].mwMrg.destroy(); }
  W.mwMrgLanding = { initAll: initAll, destroyAll: destroyAll };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  D.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  D.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });
})();
